import { gql } from '@apollo/client'
import fragments from 'graphql/fragments'

// Remote
export const GET_INVESTMENTS = gql`
  query Investments($projectId: ID!, $roundId: ID) {
    investments(projectId: $projectId, roundId: $roundId) {
      ...Investment
    }
  }
  ${fragments.investment}
`

export const CAN_DELETE_CONVERTIBLE_NOTE = gql`
  query CanDeleteCN($convertibleNoteIds: [ID!]!) {
    canDeleteCN(convertibleNoteIds: $convertibleNoteIds)
  }
`

export const GET_INVESTMENT = gql`
  query Investment($investmentId: ID!) {
    investment(investmentId: $investmentId) {
      ...Investment
    }
  }
  ${fragments.investment}
`

export const _ADD_INVESTMENT = gql`
  mutation _AddInvestment($projectId: ID!, $input: InvestmentInput!) {
    _addInvestment(projectId: $projectId, investmentInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const ADD_INVESTMENT = gql`
  mutation AddInvestment($projectId: ID!, $input: InvestmentInput!) {
    addInvestment(projectId: $projectId, investmentInput: $input) {
      ...Investment
    }
  }
  ${fragments.investment}
`

export const _SAVE_INVESTMENT = gql`
  mutation _SaveInvestment($investmentId: ID!, $input: InvestmentInput!) {
    _saveInvestment(investmentId: $investmentId, investmentInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _DELETE_INVESTMENT = gql`
  mutation _DeleteInvestment($investmentId: ID!) {
    _deleteInvestment(investmentId: $investmentId) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _SAVE_MULTIPLE_INVESTOR_CN_TRANCHES = gql`
  mutation _SaveMultipleInvestorCNTranches(
    $projectId: ID!
    $investorId: ID!
    $roundId: ID!
    $tranchenInputs: [InvestmentInput!]!
  ) {
    _saveMultipleInvestorCNTranches(
      projectId: $projectId
      investorId: $investorId
      roundId: $roundId
      tranchenInputs: $tranchenInputs
    ) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _SAVE_MULTIPLE_CN_TRANCHES = gql`
  mutation _SaveMultipleCNTranches(
    $projectId: ID!
    $roundId: ID!
    $tranchenInputs: [InvestmentInput!]!
  ) {
    _saveMultipleCNTranches(
      projectId: $projectId
      roundId: $roundId
      tranchenInputs: $tranchenInputs
    ) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _SAVE_MULTIPLE_INVESTOR_CN_CONVERSIONS = gql`
  mutation _SaveMultipleInvestorConversions(
    $projectId: ID!
    $investorId: ID!
    $roundId: ID!
    $conversionInputs: [InvestmentInput!]!
  ) {
    _saveMultipleInvestorConversions(
      projectId: $projectId
      investorId: $investorId
      roundId: $roundId
      conversionInputs: $conversionInputs
    ) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _SAVE_MULTIPLE_CN_CONVERSIONS = gql`
  mutation _SaveMultipleConversions(
    $projectId: ID!
    $roundId: ID!
    $conversionInputs: [InvestmentInput!]!
  ) {
    _saveMultipleConversions(
      projectId: $projectId
      roundId: $roundId
      conversionInputs: $conversionInputs
    ) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _SAVE_MULTIPLE_EQUITY_INVESTMENTS = gql`
  mutation _SaveMultipleEquityInvestments(
    $projectId: ID!
    $roundId: ID!
    $equityInputs: [InvestmentInput!]!
  ) {
    _saveMultipleEquityInvestments(
      projectId: $projectId
      roundId: $roundId
      equityInputs: $equityInputs
    ) {
      ...Project
    }
  }
  ${fragments.project}
`

const mutations = {
  addRemote: _ADD_INVESTMENT,
  saveRemote: _SAVE_INVESTMENT,
  deleteRemote: _DELETE_INVESTMENT,
  saveOp: '_saveInvestment',
  addOp: '_addInvestment',
  deleteOp: '_deleteInvestment',
}

export const investmentsQueries = { ...mutations, getRemote: GET_INVESTMENTS }
export const investmentQueries = { ...mutations, getRemote: GET_INVESTMENT }
